// extracted by mini-css-extract-plugin
export default {"add-manufacturer-save-button-wrapper":"addManufacturer_add-manufacturer-save-button-wrapper__Yz51O","manufacturer-detail-label":"addManufacturer_manufacturer-detail-label__VQAYc"};